type Props = {
  action: "登録" | "ログイン"
  redirect?: string | null
}

export default function OAuthButtons({ action, redirect }: Props) {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""

  const saveRedirect = () => {
    if (redirect) sessionStorage.setItem("oauth_post_redirect", redirect)
  }

  return (
    <div className="oauth-buttons">
      <form method="POST" action="/users/auth/google_oauth2" onSubmit={saveRedirect}>
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <input type="hidden" name="action_type" value={action === "ログイン" ? "login" : "signup"} />
        {redirect && <input type="hidden" name="redirect_to" value={redirect} />}
        <button type="submit" className="btn-oauth">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
          Googleで{action}
        </button>
      </form>
    </div>
  )
}
